"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2ResetType = void 0;
var SksgV2ResetType;
(function (SksgV2ResetType) {
    SksgV2ResetType[SksgV2ResetType["Soft"] = 1] = "Soft";
    SksgV2ResetType[SksgV2ResetType["Hard"] = 2] = "Hard";
    SksgV2ResetType[SksgV2ResetType["Service"] = 3] = "Service";
    SksgV2ResetType[SksgV2ResetType["HmiPower"] = 4] = "HmiPower";
    SksgV2ResetType[SksgV2ResetType["Plc"] = 5] = "Plc";
    SksgV2ResetType[SksgV2ResetType["Payment"] = 6] = "Payment";
    SksgV2ResetType[SksgV2ResetType["Modem"] = 7] = "Modem";
    SksgV2ResetType[SksgV2ResetType["MainBoard"] = 8] = "MainBoard";
    SksgV2ResetType[SksgV2ResetType["PowerCabinet"] = 9] = "PowerCabinet";
})(SksgV2ResetType = exports.SksgV2ResetType || (exports.SksgV2ResetType = {}));
